(() => {
  // app/scripts/common/component/productForm.js
  !window.customElements.get("product-form") && customElements.define(
    "product-form",
    class extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.scriptElement = this.querySelector('script[type="application/json"].object-product');
        this.JSON = this.scriptElement ? JSON.parse(this.scriptElement.textContent).product : window.theme.product;
        this.template = this.querySelector("[data-variant-template]")?.content || null;
        this.container = this.closest("popup-component") || this.closest(".shopify-section");
        this.handleKonfiguratorUpdated = this.handleKonfiguratorUpdated.bind(this);
        window.addEventListener("konfigurator:updated", this.handleKonfiguratorUpdated);
        this.container.addEventListener("change", (e) => {
          const target = e.target;
          if (target.closest("#bcpo")) {
            this.onBCPOAppChange();
          }
        });
      }
      disconnectedCallback() {
        window.removeEventListener("konfigurator:updated", this.handleKonfiguratorUpdated);
      }
      onBCPOAppChange() {
        this.updateAffirm();
        this.updateContent();
        this.calcBCPOPriceAdjustment();
      }
      updateAffirm() {
        const affirmElements = document.querySelectorAll('.affirm-as-low-as[data-page-type="product"]');
        if (!affirmElements.length || !window.bcpo || !window.bcpo.variant) return;
        affirmElements.forEach((affirmElement) => {
          affirmElement.setAttribute("data-amount", window.bcpo.variant.price);
        });
        window.affirm?.ui?.refresh?.();
      }
      calcBCPOPriceAdjustment() {
        const mainPriceElms = document.querySelectorAll(".js-main-price");
        if (!mainPriceElms.length || !window.bcpo) return;
        let bcpoPriceAdjustment = 0;
        if (window.bcpo.lastPrice) {
          bcpoPriceAdjustment = window.bcpo.lastPrice[5] - parseInt(mainPriceElms[0].dataset.origin);
        } else {
          if (!!this.querySelector(".bcpo-addons-price")) {
            bcpoPriceAdjustment = parseInt(this.cleanCurrencyString(this.querySelector(".bcpo-addons-price").textContent)) * 100;
          }
        }
        mainPriceElms.forEach((mainPriceElm) => {
          mainPriceElm.setAttribute("data-bcpo-price-adjustment", bcpoPriceAdjustment);
        });
        this.updatePriceElments();
      }
      cleanCurrencyString(str) {
        return str.trim().replace(/[^0-9.,]/g, "");
      }
      handleKonfiguratorUpdated({ detail }) {
        const { updatedPrice } = detail;
        const mainPriceElms = document.querySelectorAll(".js-main-price");
        if (!mainPriceElms.length) return;
        const konfiguratorPriceAdjustment = updatedPrice ? updatedPrice - parseInt(mainPriceElms[0].dataset.origin) : 0;
        this.konfiguratorPriceAdjustment = konfiguratorPriceAdjustment;
        mainPriceElms.forEach((mainPriceElm) => {
          mainPriceElm.setAttribute("data-konfigurator-price-adjustment", konfiguratorPriceAdjustment);
        });
        this.updatePriceElments();
      }
      updatePriceElments() {
        const mainPriceElms = document.querySelectorAll(".js-main-price");
        const comparePriceElms = document.querySelectorAll(".js-compare-price");
        const mainPrice = mainPriceElms[0];
        const comparePrice = comparePriceElms[0];
        if (!mainPrice) return;
        const konfiguratorPriceAdjustment = this.konfiguratorPriceAdjustment || (mainPrice.hasAttribute("data-konfigurator-price-adjustment") ? parseFloat(mainPrice.getAttribute("data-konfigurator-price-adjustment")) : 0);
        const bcpoPriceAdjustment = mainPrice.hasAttribute("data-bcpo-price-adjustment") ? parseFloat(mainPrice.getAttribute("data-bcpo-price-adjustment")) : 0;
        const totalPriceAdjustment = Math.max(0, bcpoPriceAdjustment + konfiguratorPriceAdjustment);
        const mainPriceNew = parseFloat(mainPrice.dataset.origin) + totalPriceAdjustment;
        mainPriceElms.forEach((mainPriceElm) => {
          mainPriceElm.set(mainPriceNew);
        });
        if (comparePrice) {
          const comparePriceNew = parseFloat(comparePrice.dataset.origin) + totalPriceAdjustment;
          comparePriceElms.forEach((comparePriceElm) => {
            comparePriceElm.set(comparePriceNew);
          });
        }
      }
      updateContent() {
        if (!window.bcpo || !window.bcpo.variant || !this.template) return;
        const template = this.template.querySelector(`[data-variant-id="${window.bcpo.variant.id}"]`);
        Array.from(document.querySelectorAll(".jsVariantUpdate")).forEach((node) => {
          const { updateId } = node.dataset;
          if (!updateId.includes(this.dataset.formId)) return;
          const target = template?.querySelector(`.jsVariantUpdate[data-update-id="${node.dataset.updateId}"]`);
          node.innerHTML = target?.innerHTML || "";
          target && (node.className = target.className);
        });
      }
    }
  );
})();
